import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ProductCard from './ProductCard';
import { Button } from './ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Menu = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('Todos');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategories();
    fetchProducts();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API}/categories`);
      setCategories([{ id: 'all', name: 'Todos' }, ...response.data]);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const fetchProducts = async (category = null) => {
    try {
      setLoading(true);
      const url = category && category !== 'Todos' ? `${API}/products?category=${category}` : `${API}/products`;
      const response = await axios.get(url);
      setProducts(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCategoryClick = (categoryName) => {
    setSelectedCategory(categoryName);
    fetchProducts(categoryName === 'Todos' ? null : categoryName);
  };

  return (
    <section id="menu" className="py-16 px-4 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto">
        <h2
          className="text-4xl sm:text-5xl font-bold text-[#291014] text-center mb-4"
          style={{ fontFamily: 'Outfit, sans-serif', letterSpacing: '-0.02em' }}
          data-testid="menu-title"
        >
          Nosso Cardápio
        </h2>
        <p
          className="text-base sm:text-lg text-[#5C4247] text-center mb-10 max-w-2xl mx-auto"
          style={{ fontFamily: 'Manrope, sans-serif' }}
          data-testid="menu-subtitle"
        >
          Escolha seus petiscos favoritos e faça seu pedido
        </p>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-3 mb-10" data-testid="category-filter">
          {categories.map((category) => (
            <Button
              key={category.id}
              onClick={() => handleCategoryClick(category.name)}
              variant={selectedCategory === category.name ? 'default' : 'outline'}
              className={
                selectedCategory === category.name
                  ? 'bg-[#7F1D1D] hover:bg-[#991B1B] text-white rounded-full px-6'
                  : 'border-[#7F1D1D] text-[#7F1D1D] hover:bg-[#7F1D1D] hover:text-white rounded-full px-6'
              }
              data-testid={`category-button-${category.name}`}
            >
              {category.name}
            </Button>
          ))}
        </div>

        {/* Products Grid */}
        {loading ? (
          <div className="text-center py-20" data-testid="loading-indicator">
            <p className="text-[#5C4247]" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Carregando produtos...
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="products-grid">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Menu;